import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'
import axios from 'axios'

// Styles
import styles from './styles'

// Material UI
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import ExpansionPanel from 'material-ui/ExpansionPanel'
import ExpansionPanelSummary from 'material-ui/ExpansionPanel/ExpansionPanelSummary'
import ExpansionPanelDetails from 'material-ui/ExpansionPanel/ExpansionPanelDetails'
import Button from 'material-ui/Button'
import ExpandMoreIcon from 'material-ui-icons/ExpandMore'
import DeleteIcon from 'material-ui-icons/Delete'

import { saveData } from './actions'

class Row extends Component {
  constructor(props) {
    super(props)

    this.state = {
      income_levels: [
        'Everyone',
        'Up to $25,000',
        '$25,000 and above',
        '$35,000 and above',
        '$50,000 and above',
        '$75,000 and above',
        '$100,000 and above',
        '$150,000 and above'
      ],
      education_levels: [
        'Everyone',
        'High School or above',
        'Some College or above',
        'Associate Degree or above',
        'Bachelor Degree or above',
        'Graduate Degree or above',
        'PHD / Post Doctoral'
      ]
    }
  }

  onTap(data) {
    //alert(JSON.stringify(data))
    this.props.saveData(data['Search_ID'])
    if (data['Search_Name'] === 'All Candidates') {
      this.props.changeRoute(
        '/console/search/saved_searches/filter?name=' +
          data['Search_Name'] +
          '&search_id=' +
          data['Search_ID'] +
          '&count=' +
          data['searchCount']
      )
    } else {
      this.props.changeRoute(
        '/console/search/saved_searches/filter/color_priority?name=' +
          data['Search_Name'] +
          '&search_id=' +
          data['Search_ID'] +
          '&count=' +
          data['searchCount']
      )
    }
  }

  onDelete(data) {
    //alert(JSON.stringify(data))
    let url = `https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/customer/${
      this.props.customer_number
    }/pw/teSt1/filter/${data.pkey}`
    axios.get(url).then(function(response) {
      window.location.reload()
    })
  }

  render() {
    const { classes, theme, location, data } = this.props

    let oar = <div />
    let age = <div />
    let opa = <div />
    let education = <div />
    let income = <div />

    if (data.Oar_Low && data.Oar_High) {
      oar = (
        <Typography>
          OAR: {data.Oar_Low} - {data.Oar_High}
        </Typography>
      )
    }

    if (data.Youngest_Dating_Age && data.Oldest_Dating_Age) {
      age = (
        <Typography>
          AGE: {data.Youngest_Dating_Age} - {data.Oldest_Dating_Age}
        </Typography>
      )
    }

    if (data.Profile_Oldest_Dating_Age) {
      opa = (
        <Typography>
          Oldest Preferred Age: {data.Profile_Oldest_Dating_Age}
        </Typography>
      )
    }

    if (data['Education_Low'] >= 0) {
      education = (
        <Typography>
          Education: {this.state.education_levels[data.Education_Low]}
        </Typography>
      )
    }

    if (data.Income_Low >= 0) {
      income = (
        <Typography>
          Income: {this.state.income_levels[data.Income_Low]}
        </Typography>
      )
    }

    if (data.Search_Name === 'All Candidates') {
      return (
        <div className={classes.root}>
          <ExpansionPanel>
            <ExpansionPanelSummary
              className={classes.exp}
              expandIcon={<ExpandMoreIcon />}
            >
              <Typography className={classes.heading}>
                {data['Search_Name']}
              </Typography>
              <Button
                className={classes.button}
                onClick={() => this.onTap(data)}
                color="primary"
              >
                Search
              </Button>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <div className={classes.details}>
                <br />
                <Typography>
                  This saved search contains an unfiltered list of all the users
                  in our database.
                </Typography>
                <br />
                <Typography type="body2">Active Population Count:</Typography>
                <Typography>{data.searchCount}</Typography>
              </div>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </div>
      )
    } else {
      return (
        <div className={classes.root}>
          <ExpansionPanel>
            <ExpansionPanelSummary
              className={classes.exp}
              expandIcon={<ExpandMoreIcon />}
            >
              <Typography className={classes.heading}>
                {data['Search_Name']}
              </Typography>
              <Button
                className={classes.button}
                onClick={() => this.onTap(data)}
                color="primary"
              >
                Search
              </Button>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <div className={classes.details}>
                <br />
                <Typography type="body2">Filter Properties:</Typography>
                <br />
                {oar}
                {age}
                {opa}
                {education}
                {income}
                <br />
                <br />
                <Typography type="body2">Active Population Count:</Typography>
                <Typography>{data.searchCount}</Typography>
                <br />
                <br />
                <Button
                  aria-label="Delete Saved Search"
                  className={classes.deleteButton}
                  onClick={() => this.onDelete(data)}
                  color="primary"
                >
                  <DeleteIcon className={classes.rightIcon} />
                </Button>
              </div>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </div>
      )
    }
  }
}

function mapStateToProps(state) {
  return {
    customer_number: state.customer.number,
    project_id: state.prefix.project_id
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch,
    saveData: bindActionCreators(saveData, dispatch),
    changeRoute: url => dispatch(push(url))
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, mapDispatchToProps)(Row)
  )
)



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/SavedSearches/components/Row/index.js